import { useEffect, useState } from 'react';
import { EventSourceInput } from '@fullcalendar/core';
import moment from 'moment-timezone';
import { useTheme } from 'react-jss';

import { Theme } from '@app/theme';

export const useDisabledBackgroundEvents = (timezone: string) => {
  const [disabledBackgroundEvents, setDisabledBackgroundEvents] =
    useState<EventSourceInput>({});
  const theme: Theme = useTheme();

  useEffect(() => {
    setDisabledBackgroundEvents({
      events: [
        {
          id: 'invalidToday',
          start: moment.tz(timezone).startOf('day').toISOString(true),
          end: moment().tz(timezone).toISOString(true),
          display: 'background',
          backgroundColor: theme.colors.grayBorder,
        },
        {
          id: 'previousDays',
          endRecur: moment().tz(timezone).startOf('day').toISOString(true),
          display: 'background',
          backgroundColor: theme.colors.grayBorder,
        },
      ],
    });
  }, [timezone, theme]);
  return disabledBackgroundEvents;
};
